import type { ReactNode } from 'react';

import type { TerminalOrGroup, TerminalOrGroupOption, TerminalOrGroupTerminal } from './types';

export const formatTerminalOrGroupLabel = (option: TerminalOrGroup): ReactNode => {
  const { label } = option;

  return label;
};

export const isTerminalGroup = (option: TerminalOrGroup): boolean => option.terminals.length > 0;

export const getGroupMemberIds = (options: TerminalOrGroup[]): Set<string> =>
  new Set(
    options
      .filter(isTerminalGroup)
      .flatMap((group: TerminalOrGroup): string[] =>
        group.terminals.map((terminal: TerminalOrGroupTerminal): string => terminal.id)
      )
  );

export const isGroupMemberOption = (option: TerminalOrGroupOption): boolean => !!option.isGroupMember;

export const withGroupMembersAsOptions = (options: TerminalOrGroup[]): TerminalOrGroupOption[] => {
  const memberIds: Set<string> = getGroupMemberIds(options);

  return options.flatMap((option: TerminalOrGroup): TerminalOrGroupOption[] => {
    if (!isTerminalGroup(option)) {
      return memberIds.has(option.id) ? [] : [option];
    }

    const memberOptions: TerminalOrGroupOption[] = option.terminals.map(
      (terminal: TerminalOrGroupTerminal): TerminalOrGroupOption => ({
        ...terminal,
        isGroupMember: true,
        label: `${terminal.label} (${option.label})`,
        terminals: []
      })
    );

    return [option, ...memberOptions];
  });
};
